import React from 'react';
import classes from './NavigationItems.css'
import NavigationItem from './NavigationItem/NavigationItem';

const navigationItems=(props)=>(
    <ul className={classes.NavigationItems}>         
        <NavigationItem link="/" active >Burger Builder</NavigationItem>        
        {props.isAuthenticated
            ?<><NavigationItem link="/orders" >Orders</NavigationItem>
             <NavigationItem link="/logout" >Logout</NavigationItem>
             </>
            :<NavigationItem link="/auth" >Auth</NavigationItem>
        }
        
    </ul>
)

export default navigationItems